import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import loadable from '@loadable/component';
import { EFormStep } from '../../types';
import { useFormStep } from './hooks/useFormStep';
import { LoadableErrorBoundary } from '../../packages/LoadableHelpers';
import { ButtonContainer } from '../ButtonContainer';
import { useWidgetContext } from '../../shared/context';
var ModalContainerLoadable = loadable(function () {
  return import(
  /* webpackChunkName: "ModalContainerLoadable" */
  '../ModalContainer');
}, {
  resolveComponent: function resolveComponent(component) {
    return component.ModalContainer;
  },
  ssr: false
});
export var WidgetContainer = function WidgetContainer() {
  var _useWidgetContext = useWidgetContext(),
      logger = _useWidgetContext.logger,
      buttonProps = _useWidgetContext.buttonProps,
      open = _useWidgetContext.open;

  var formStep = useFormStep(open);
  var step = formStep.step,
      openForm = formStep.openForm;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      locationSuggestions = _React$useState2[0],
      setLocationSuggestions = _React$useState2[1];

  var retryLoadContent = React.useCallback(function () {
    ModalContainerLoadable.load();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonContainer, _extends({}, buttonProps, {
    openForm: openForm
  })), step !== EFormStep.Closed && /*#__PURE__*/React.createElement(LoadableErrorBoundary, {
    onRetry: retryLoadContent,
    logger: logger
  }, /*#__PURE__*/React.createElement(ModalContainerLoadable, _extends({}, formStep, {
    locationSuggestions: locationSuggestions,
    setLocationSuggestions: setLocationSuggestions
  }))));
};